import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _booking = {
    createdDate: 'google.protobuf.Timestamp',
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    canceledDate: 'google.protobuf.Timestamp',
    contactDetails: '_contactDetails',
};
var _contactDetails = { fullAddress: '_address' };
var _countExtendedBookingsRequest = {};
var _countExtendedBookingsResponse = {};
var _extendedBooking = { booking: '_booking' };
var _queryExtendedBookingRequest = {};
var _queryExtendedBookingResponse = { extendedBookings: '_extendedBooking' };
var _queryExtendedBookingsRequest = {};
var _queryExtendedBookingsResponse = { extendedBookings: '_extendedBooking' };
function resolveComWixpressBookingsReaderV2BookingsReaderUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/bookings-reader',
                destPath: '',
            },
        ],
        'editor._base_domain': [
            {
                srcPath: '/_api/bookings-reader',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings-reader',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings-reader',
                destPath: '',
            },
            {
                srcPath: '/bookings/bookings-reader',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/bookings-reader',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/bookings-reader',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/bookings-reader',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * > **Deprecation Notice**
 * >
 * > **This endpoint has been replaced with [Query Extended Bookings](https://dev.wix.com/api/rest/wix-bookings/bookings-reader-v2/query-extended-bookings) and will be removed on May 31, 2025.**
 * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
 *
 *
 * Retrieves a list of bookings, given the provided paging, filtering, and sorting.
 *
 *
 * You can also retrieve information about which actions the customer can perform
 * for the bookings. To do so, pass `withBookingAllowedActions` as `true`.
 *
 * Query Bookings runs with these defaults:
 *
 * - `createdDate` sorted in `DESC` order
 * - `cursorPaging.limit` is `50`
 *
 * You can check the overview about all
 * [supported filters](https://dev.wix.com/api/rest/wix-bookings/bookings-reader-v2/supported-filters)
 * for more information.
 *
 * `query.fields` and `query.fieldsets` aren't supported for this endpoint.
 *
 * When using filters for dates, you must use [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
 *
 * Bookings belonging to a schedule don't have a `sessionId`. Therefore you
 * must use the `sessionId` filter that isn't part of the `query` object to
 * filter bookings for courses.
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 *
 * When calling Query Bookings, the retrieved data may not contain your most recent changes. See
 * [Wix-data and Eventual Consistency](reference/wix-data/introduction#wix-data_introduction_wix-data-and-eventual-consistency)
 * for more information.
 * @deprecated
 */
export function query(payload) {
    var _a = serializer(_queryExtendedBookingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryExtendedBookingResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _booking: _booking,
        _contactDetails: _contactDetails,
        _extendedBooking: _extendedBooking,
    }).fromJSON;
    function __query(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.reader.v2.extended_booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.reader.v2.BookingsReader.Query',
            url: resolveComWixpressBookingsReaderV2BookingsReaderUrl({
                protoPath: '/v2/extended-booking/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __query.fromReq = fromReq;
    __query.__isAmbassador = true;
    return __query;
}
/**
 * Retrieves up to 100 bookings, given the specified paging, filtering, and sorting.
 *
 *
 * Query Extended Bookings runs with these defaults, which you can override:
 *
 * - `id` sorted in `ASC` order
 * - `cursorPaging.limit` is `50`
 *
 * To retrieve course bookings, filter by `scheduleId` of the relevant
 * service.
 *
 * You can retrieve information about which actions the customer can perform
 * for the bookings. To do so, pass `withBookingAllowedActions` as `true`.
 *
 * For field support see
 * [supported filters](https://dev.wix.com/api/rest/wix-bookings/bookings-reader-v2/supported-filters)
 * for more information.
 *
 * When using filters for dates, you must use [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryExtendedBookings(payload) {
    var _a = serializer(_queryExtendedBookingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryExtendedBookingsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _booking: _booking,
        _contactDetails: _contactDetails,
        _extendedBooking: _extendedBooking,
    }).fromJSON;
    function __queryExtendedBookings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.reader.v2.extended_booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.reader.v2.BookingsReader.QueryExtendedBookings',
            url: resolveComWixpressBookingsReaderV2BookingsReaderUrl({
                protoPath: '/v2/extended-bookings/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryExtendedBookings.fromReq = fromReq;
    __queryExtendedBookings.__isAmbassador = true;
    return __queryExtendedBookings;
}
/**
 * Counts the number of bookings matching the specified filters.
 *
 *
 * For field support see
 * [supported filters](https://dev.wix.com/api/rest/wix-bookings/bookings-reader-v2/supported-filters)
 * for more information.
 */
export function countExtendedBookings(payload) {
    var _a = serializer(_countExtendedBookingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countExtendedBookingsResponse, {}).fromJSON;
    function __countExtendedBookings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.reader.v2.extended_booking',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.reader.v2.BookingsReader.CountExtendedBookings',
            url: resolveComWixpressBookingsReaderV2BookingsReaderUrl({
                protoPath: '/v2/extended-bookings/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countExtendedBookings.fromReq = fromReq;
    __countExtendedBookings.__isAmbassador = true;
    return __countExtendedBookings;
}
//# sourceMappingURL=http.impl.js.map